import type { AssetsLink } from '#/domain/assetsLink/AssetsLink'
import type { AssetsLinkRepository } from '#/domain/assetsLink/AssetsLinkRepository'

export class CreateAssetsLinkUseCase {
  constructor(private readonly repository: AssetsLinkRepository) {}

  async execute(assetsLink: AssetsLink): Promise<AssetsLink> {
    return this.repository.create(assetsLink)
  }
}
